import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, } from '@angular/common/http';

import { map, share } from 'rxjs/operators';
import { LocalStorageService } from './storage.service';

import { Router } from '@angular/router';

import { Observable, of } from 'rxjs';
import { State } from './state';
import {StateService} from './stateService';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private accountObservable$!: Observable<any>;

  constructor(
    public router: Router,
    private http: HttpClient,
    private stateService : StateService,
    private storageService: LocalStorageService,

    // private socialAuthService: SocialAuthService
    ) {}

  public authenticate(credentials: Credentials, appContext: string = "", canRegister: boolean = true) {
    const headers: HttpHeaders = new HttpHeaders().set('allowDupes', 'true').set('canRegister', canRegister.toString()).set('X-Application-Context', appContext);;
    return this.http.post(State.config.host + '/api/authenticate', credentials, { headers: headers, observe: 'response' })
      .pipe(map((response: any) => {
        console.log('auth service, success', response);
        this.authenticateSuccess(response, credentials);
        return 'Bearer ' + response.body.id_token;
      }, (error: any) => {
        this.authenticateFailure(error);
      }));
  }


  public authenticateSuccess (response: HttpResponse<any>, credentials: Credentials) {
    console.log('AuthService',"in authenticateSuccess");

    console.log('AuthService',response );

    var bearerToken = 'Bearer ' + response.body.id_token;
    //console.log('AuthService',"bearerToken=" + bearerToken);
    if (bearerToken) {
      console.log('AuthService',"Setting jwt does it already exist?=" + (null != State.jwt));
      State.setJwt(bearerToken);
      if(credentials.rememberMe)
        this.storageService.set('jwt', bearerToken);
      this.storageService.set('hasLoggedIn', 'true');
      State.loggedOut = false;
      /*
      if (response.headers.has('shouldReset'))
        return "shouldReset";
      */
      State.justRegistered = response.headers.has('justRegistered');
      console.log('AuthService',"attempting from auth");

      return this.refreshCurrentUser(true);
    } else {
      console.log('AuthService',bearerToken);
      console.log('AuthService','Not defining profile');
      return null;
    }

  }

  public authenticateFailure (data : any | undefined) {
   console.log('AuthService',"in authenticateFailure");
    console.log('AuthService',data);
    var msg : string = "failure " + data.AuthenticationException;

    console.log('AuthService',"status=" + data.status);
    console.log('AuthService',"headers=" + data.headers);
    if (msg)
      return msg;
    else
      return "failure";
  }

  public authenticated() {
    //return tokenNotExpired('jwt');
    var token = State.jwt;
    // console.log('AuthService',"TOKEN=" + token);
    return token != null;
    // const jwtHelper = new JwtHelper();
    // return token != null && !jwtHelper.isTokenExpired(token);
  }

  public verifyAccount(data: any) {
    const headers: HttpHeaders = new HttpHeaders().append('allowDupes', 'true');
    return this.http.post(State.config.host + '/api/verify', data, { headers: headers }).pipe(map((response: any) => {
      return response;
    }, (error: any) => {
      throw error;
    }));
  }

  public getNewVerificationCode(data: any) {
    const headers: HttpHeaders = new HttpHeaders().append('allowDupes', 'true');
    return this.http.post(State.config.host + '/api/verificationCode', data, { responseType: 'text', headers: headers }).pipe(map((response: any) => {
      return response;
    }, (error: any) => {
      throw error;
    }));
  }

  public getAccount(token: string) {
    console.log('Entering getAccount', token);
    if (!token)
      return of({});
    const regex = /"/ig;
    token = token.replace(regex, '');
    console.log(token);
    const headers: HttpHeaders = new HttpHeaders().set('Authorization', token);
    return this.http.get(State.config.host + '/api/account', { headers: headers }).pipe(map((response: any) => {
      return response;
    }, (error: any) => {
      throw error;
    }));
  }

  public login(credentials: Credentials, appContext: string = "", canRegister: boolean = true): Promise<any> {
    return this.authenticate(credentials, appContext, canRegister).toPromise().then((token: any) => {
      return this.getAccount(token).toPromise().then((user: any) => {
        //console.log("AuthService", user);
        this.setUserAuth(token, user.email, user);

        if(credentials.rememberMe == null)
          credentials.rememberMe = false;
        let promises = [
          this.storageService.set('email', user.email),
          this.storageService.set('Trusted-User', user.email),
          this.storageService.set('jwt', token)
        ];
        return Promise.all(promises).then(() => {
          this.stateService.loadInitialState();
          return user;
        }, (error: any) => {
          throw error;
        });
      }, (error: any) => {
        throw error;
      });
    }, (error: any) => {
      throw error;
    });
  }

  public refreshCurrentUser( force? : boolean) {
    console.log("entering refreshCurrentUser");

   var authHeader = this.getAuthenticationHeaders().append('allowDupes', 'true');
   if (State.jwt && (!this.accountObservable$ || force)) {
       console.log("Calling account service");

       this.accountObservable$ = this.http.get(State.config.host + '/api/account',  { headers: authHeader })
       .pipe(share());

       return this.accountObservable$.toPromise().then(user => {
         State.loggedOut = false;
         console.log("GOT USER!!!!! loggedOut = " + State.loggedOut + " user=" + user);
         if(!State.user || !State.user.userObj || user != State.user.userObj) {
           console.log("SETTING USER!!!!");
           console.log('refreshCurrentUser user=', user);
           var itsANewUser : boolean =  (null == State.user) || (!user.hasOwnProperty('login')) || (user != State.user);
           this.setUserAuth(State.jwt, user.email, user);

          if (State.user && State.user.userObj.fullyRegistered) {
              this.storageService.set('fullyRegistered', 'true');
          }

         }
         return State.user ? State.user.userObj : undefined;
       },(err=>
           {

              console.log("ERROR IN REFRESHCURRENT USER status=" + err.status);
              console.log(err);
              if (err.status == 401) {
                State.loggedOut = true;
              }
       }));
     }
     return undefined;
    }


     public getAuthenticationHeaders() : HttpHeaders {
      console.log("getAuthenticationHeaders",  State.user);
       if(State.jwt != null) {
       var authHeader =  new HttpHeaders({'Authorization' : State.jwt});
       let trustedUser : string | null = null;
      if (State.user && State.user.userObj)
           trustedUser = State.user.userObj.login;
       if (null == trustedUser)
        console.log('SharedService',"WARNING!!! trusted user could not be resolved in getAuthHeaders");
       else
           authHeader = authHeader.set('Trusted-User', trustedUser);
       return authHeader;
       } else {
           return new HttpHeaders();
       }
  }

  public isUserAdmin() : boolean {
    return State.user?.userObj.authorities.indexOf('COORDINATOR') > -1 || State.user?.userObj.authorities.indexOf('PROJECT_LEAD') > -1 ;
  }


  public setUserAuth(jwt: string | undefined, trustedUser: string | undefined, user?: any){
    console.log('setUserAuth', trustedUser);
    State.setJwt(jwt);
    State.user = {
      trustedUser : trustedUser,
      userObj :  user
    };

    console.log('setUserAuth', State.getAuthHeaders());
  }

  logout() {
    console.log('in logout');
    this.setUserAuth(undefined, undefined, null);
    State.logout();
    this.storageService.remove('jwt');
    this.storageService.remove('email');
    this.storageService.remove('Trusted-User');
    State.shouldLogout = false;
  }

}

export interface Credentials {
  username: string | undefined | null;
  password: string;
  deviceUUID: string | undefined | null;
  rememberMe?: boolean;
  newEmail?: any;
  isBrowser? : boolean,
  deviceToken?: string | undefined | null;
  firebaseToken?: string;
  photoURL?: string;


  // con
}
